//Y Label detailed function
import * as d3 from "d3";
export function labeledYAxis(selection, props) {
  const {
    yAxisLabelFill,
    yAxisLabelOffset,
    yAxisTickFontSize,
    yAxisLabelFontSize,
    AxisTickFontFill,
    AxisTickLineStroke,
    yScale,
    innerHeight,
  } = props;

  const yAxis = d3.axisLeft(yScale).tickSize(-innerWidth);
  // .tickPadding(18)
  // .ticks(8)
  // .tickFormat(d3.format(".2"));

  let yAxisG = selection.selectAll(".AxisY").data([null]);
  yAxisG = yAxisG.enter().append("g").attr("class", "AxisY").merge(yAxisG);
  yAxisG.call(yAxis);
  const labels = yAxisG
    .selectAll(".tick text")
    .attr("font-size", yAxisTickFontSize)
    .attr("fill", AxisTickFontFill)
    .attr("x", "-14px");

  yAxisG
    .selectAll(".tick line")
    .attr("stroke", AxisTickLineStroke)
    .attr("display", "none");
  yAxisG.select(".domain").attr("opacity", 0);

  //const labels = yAxisG.selectAll('.tick');
  //yAxisG.selectAll('.tick').call(wrap);

  //Labels
  const yAxisLabel = yAxisG.selectAll(".axisLabelY").data([null]);
  yAxisLabel
    .enter()
    .append("text")
    .attr("class", "axisLabelY")
    .merge(yAxisLabel)
    .text("Index 1 March 2020 = 100")
    .attr("text-anchor", "end")
    .attr("fill", yAxisLabelFill)
    .attr("x", -innerHeight / 4 + 96)
    // .attr(
    //   "x",
    //   yScale(
    //     d3.max((d) => {
    //       d.demand;
    //     })
    //   )
    // )
    .attr("y", -yAxisLabelOffset)
    .attr("transform", "rotate(-90)")
    .style("font-size", yAxisLabelFontSize);
}
